import './CarruselOfertas.css';
import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import oferta1 from '../assets/Imagen.png';
import oferta2 from '../assets/Imagen2.png';
import oferta3 from '../assets/Imagen3.png';
import oferta4 from '../assets/Imagen4.png';
import oferta5 from '../assets/Imagen5.png';
import oferta6 from '../assets/Imagen6.png';
import oferta7 from '../assets/Imagen7.png';
import oferta8 from '../assets/Imagen8.png';
import oferta9 from '../assets/Imagen9.png';

const ofertas = [
  { img: oferta1, title: 'Oferta 1' },
  { img: oferta2, title: 'Oferta 2' },
  { img: oferta3, title: 'Oferta 3' },
  { img: oferta4, title: 'Oferta 4' },
  { img: oferta5, title: 'Oferta 5' },
  { img: oferta6, title: 'Oferta 6' },
  { img: oferta7, title: 'Oferta 7' },
  { img: oferta8, title: 'Oferta 8' },
  { img: oferta9, title: 'Oferta 9' },
];

const CarruselOfertas = () => {
  return (
    <div className="ofertas-page">

      <div className="ofertas-hero">
        <h1>🔥 Ofertas MonkeyPhone</h1>
        <p>Los mejores planes para que siempre estés conectado. Desliza y encuentra el tuyo.</p>
      </div>

      <div className="ofertas-carousel-card">
        <Carousel
          autoPlay
          infiniteLoop
          showThumbs={false}
          showStatus={false}
          showIndicators={true}
          interval={4000}
          transitionTime={800}
          swipeable
          emulateTouch
        >
          {ofertas.map((oferta, index) => (
            <div className="ofertas-slide" key={index}>
              <img src={oferta.img} alt={oferta.title} />
            </div>
          ))}
        </Carousel>
      </div>

      <div className="ofertas-cta">
        <a href="/Consulta" className="ofertas-cta-btn">
          Comprar ahora
        </a>
      </div>

    </div>
  );
};

export default CarruselOfertas;
